module.exports = __webpack_public_path__ + "static/media/phone-outgoing-blue.69e79973.svg";